<template>
  <v-fab-transition>
    <slot />
  </v-fab-transition>
</template>
